export const companyInfo = {
  name: "Rota Giardinaggio",
  fullName: "Rota Adriano Battista & C. sas",
  tagline: "Il giardino dei desideri",
  mission: "Il giardino dei desideri nasce dall'esigenza di creare la cultura di un nuovo habitat verde. La nostra mission è realizzare il giardino perfetto per te: il giardino dei tuoi desideri.",
  address: "via Ca' Felisa, 4 - 24030 Locatello (BG)",
  phone: "348 3701298",
  email: "rota.adrianobattista@libero.com",
  yearsExperience: 25,
  projectsCompleted: 500,
};

export const services = [
  {
    id: "progettazione-e-creazione-giardini",
    title: "Progettazione e creazione giardini",
    shortTitle: "Progettazione Giardini",
    icon: "Sprout",
    image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_modern-garden-4/artifacts/vnkkf43w_FD0DCA1C-9F66-4F3A-AC58-FAD78E2D1D7C.webp",
    imagePosition: "center 85%",
    description: "Creiamo giardini residenziali, aziendali e parchi su misura per te. Ogni spazio verde è unico come chi lo vive.",
    longDescription: "La progettazione di un giardino richiede sensibilità, esperienza e passione. Ci occupiamo di ogni fase: dallo studio dell'esposizione solare alla scelta delle essenze più adatte, fino alla realizzazione completa. Ogni giardino è un'opera d'arte personalizzata.",
    features: ["Preventivo dettagliato senza impegno", "Giardini residenziali su misura", "Parchi e aree verdi aziendali", "Selezione essenze e piante", "Impianti di irrigazione automatici"],
    extraImages: [{ url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_modern-garden-4/artifacts/e33rqp21_IMG%209197.webp" }],
  },
  {
    id: "potature-dalto-fusto",
    title: "Potature d'alto fusto",
    shortTitle: "Potature Alto Fusto",
    icon: "TreePine",
    image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_modern-garden-4/artifacts/6b85g0xg_IMG%204444.webp",
    rotate: true,
    description: "Potature d'alto fusto e abbattimenti con cestello elevatore in totale sicurezza.",
    longDescription: "Le potature d'alto fusto richiedono attrezzature specializzate e personale altamente qualificato.",
    features: ["Cestello elevatore fino a 25m", "Tecniche di tree climbing", "Abbattimenti controllati", "Smaltimento e cippatura", "Personale certificato", "Interventi in totale sicurezza"],
  },
  {
    id: "manutenzioni-ordinarie",
    title: "Manutenzioni ordinarie",
    shortTitle: "Manutenzioni Ordinarie",
    icon: "Scissors",
    image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_modern-garden-4/artifacts/redfrmnr_6017A798-BFD1-46AC-B035-6F85904424D7.webp",
    description: "Manutenzioni programmate per mantenere il tuo giardino sempre curato e rigoglioso.",
    longDescription: "Offriamo contratti di manutenzione ordinaria personalizzati per mantenere il verde in perfetta salute.",
    extraImages: [
      { url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_modern-garden-4/artifacts/pedrgomv_IMG%200383.webp", rotate: true, rotateDeg: 90 },
      { url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_modern-garden-4/artifacts/atzf4lwd_IMG%200515.jpg", rotate: true },
    ],
    features: ["Contratti di manutenzione annuali", "Taglio prato professionale", "Potatura siepi e arbusti", "Potatura piante da frutto", "Concimazioni stagionali", "Pulizia foglie e detriti"],
  },
  {
    id: "manutenzioni-straordinarie",
    title: "Manutenzioni straordinarie",
    shortTitle: "Manutenzioni Straordinarie",
    icon: "Wrench",
    image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_modern-garden-4/artifacts/dnvp7jso_IMG%205809.webp",
    description: "Interventi mirati per il ripristino di giardini e aree verdi trascurate o danneggiate.",
    longDescription: "Ci occupiamo del ripristino di aree verdi trascurate, sfoltimenti importanti e riqualificazione completa di giardini abbandonati.",
    extraImages: [{ url: "/images/escavatore trincia.jpg", caption: "Pulizia aree incolte" }],
    features: ["Ripristino aree trascurate", "Sfoltimenti importanti", "Rifacimento prato", "Rimozione piante malate", "Bonifica del verde", "Riqualificazione giardini"],
  },
  {
    id: "trattamenti-fitosanitari",
    title: "Trattamenti fitosanitari",
    shortTitle: "Trattamenti Fitosanitari",
    icon: "Droplets",
    image: "https://images.pexels.com/photos/4894608/pexels-photo-4894608.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    description: "Trattamenti di concimazione e disinfezione antiparassitaria per piante sane e vigorose.",
    longDescription: "Offriamo trattamenti fitosanitari professionali con prodotti certificati per la difesa da parassiti.",
    features: ["Concimazioni professionali", "Disinfezione antiparassitaria", "Prodotti certificati", "Diagnosi delle patologie", "Piani nutrizionali personalizzati", "Prevenzione e cura"],
  },
  {
    id: "lavori-di-scavo",
    title: "Lavori di scavo",
    shortTitle: "Lavori di Scavo",
    icon: "Shovel",
    image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_modern-garden-4/artifacts/yy46lmkc_22.webp",
    description: "Movimento terra e lavori di scavo con mezzi meccanici professionali.",
    longDescription: "Disponiamo di mezzi meccanici professionali per eseguire scavi, movimento terra, drenaggi e fondazioni.",
    features: ["Escavatori di varie dimensioni", "Movimento terra", "Scavi per fondazioni", "Drenaggi e canalizzazioni", "Preparazione terreni", "Livellamenti di precisione"],
  },
  {
    id: "noleggio-gru",
    title: "Noleggio gru con operatore",
    shortTitle: "Noleggio Gru",
    icon: "ArrowUpFromLine",
    image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_modern-garden-4/artifacts/mh40yay9_9BD766E0-21FD-4B69-831C-1DE2C67F9057.jpg",
    description: "Noleggio gru con operatore qualificato per sollevamento materiale vario.",
    longDescription: "Servizio di noleggio gru con operatore specializzato per il sollevamento di materiali di qualsiasi tipo.",
    features: ["Operatore qualificato incluso", "Portata fino a 3 tonnellate", "Sollevamento piante grandi", "Materiali edili", "Assicurazione completa", "Disponibilità su appuntamento"],
  },
  {
    id: "irrigazione-automatica",
    title: "Irrigazione automatica",
    shortTitle: "Irrigazione Automatica",
    icon: "CloudRain",
    image: "https://images.pexels.com/photos/37720375/pexels-photo-37720375.jpeg",
    description: "Progettazione e installazione di impianti di irrigazione automatica per giardini sempre rigogliosi.",
    longDescription: "Progettiamo e installiamo impianti di irrigazione automatica su misura per ogni tipo di giardino.",
    features: ["Progettazione personalizzata", "Irrigatori pop-up e a goccia", "Centraline programmabili", "Sensori pioggia integrati", "Risparmio idrico garantito", "Manutenzione e assistenza"],
  },
];

export const galleryImages = [
  { id: 3, url: "/images/rose.jpeg", title: "Rose in varietà", category: "Giardini" },
  { id: 4, url: "/images/opere%20urb.jpeg", title: "Progetto in realizzazione", category: "Realizzazioni" },
  { id: 5, url: "/images/laterlite.jpeg", title: "Realizzazione fioriere", category: "Realizzazioni" },
  { id: 6, url: "/video/cippatura.mp4", title: "Potatura e cippatura", category: "Potature" },
  { id: 9, url: "/images/suncity1.jpeg", title: "sfalcio erba", category: "Manutenzione" },
  { id: 11, url: "/images/potature.jpeg", title: "Potatura alto fusto", category: "Potature" },
  { id: 17, url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_modern-garden-4/artifacts/vnkkf43w_FD0DCA1C-9F66-4F3A-AC58-FAD78E2D1D7C.webp", title: "Progettazione corte interna", category: "Realizzazioni" },
  { id: 18, url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_modern-garden-4/artifacts/6b85g0xg_IMG%204444.webp", title: "Potatura d'alto fusto", category: "Potature", rotate: true },
  { id: 19, url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_modern-garden-4/artifacts/redfrmnr_6017A798-BFD1-46AC-B035-6F85904424D7.webp", title: "sfalcio erba con raccolta", category: "Manutenzione" },
  { id: 20, url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_modern-garden-4/artifacts/dnvp7jso_IMG%205809.webp", title: "Ripristino aree verdi", category: "Manutenzione" },
  { id: 21, url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_modern-garden-4/artifacts/yy46lmkc_22.webp", title: "Escavatore Kubota", category: "Scavi" },
  { id: 22, url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_modern-garden-4/artifacts/mh40yay9_9BD766E0-21FD-4B69-831C-1DE2C67F9057.jpg", title: "Sollevamento con gru", category: "Gru" },
  { id: 23, url: "https://images.pexels.com/photos/37720375/pexels-photo-37720375.jpeg", title: "Impianto irrigazione", category: "Irrigazione" },
  { id: 25, url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_modern-garden-4/artifacts/pedrgomv_IMG%200383.webp", rotate: true, title: "Sun city - Dalmine", category: "Manutenzione" },
  { id: 26, url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_modern-garden-4/artifacts/atzf4lwd_IMG%200515.jpg", title: "Manutenzione tappeto erboso", category: "Manutenzione" },
  { id: 27, url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_modern-garden-4/artifacts/e33rqp21_IMG%209197.webp", title: "Giardino interno", category: "Realizzazioni" },
];

export const heroImage = "https://customer-assets-7cd3h4nn.emergentagent.net/job_modern-garden-4/artifacts/vnkkf43w_FD0DCA1C-9F66-4F3A-AC58-FAD78E2D1D7C.webp";
export const aboutImage = "https://customer-assets-7cd3h4nn.emergentagent.net/job_modern-garden-4/artifacts/s8bb724i_Bimbi.png";

export const testimonials = [
  { id: 1, name: "Marco Bianchi", location: "Bergamo", text: "Professionalità e passione al servizio del verde.", rating: 5 },
  { id: 2, name: "Laura Ferrari", location: "Locatello", text: "Persone serie, puntuali e con grande esperienza.", rating: 5 },
  { id: 3, name: "Giovanni Rossi", location: "Zogno", text: "Servizio di potatura eseguito in totale sicurezza.", rating: 5 },
];
